export const SYMBOLS = ['AAPL', 'TSLA', 'NVDA', 'MSFT', 'AMD', 'COIN', 'PLTR', 'META', 'NFLX', 'GOOGL', 'AMZN', 'BRK.B', 'V', 'JPM', 'UNH'];
export const FIB_SEQUENCE = [2, 3, 5, 8, 13, 21];

export const ADJECTIVES = ["Bullish", "Bearish", "Tenacious", "Volatile", "Leveraged", "Liquid", "Contrarian", "Scalping", "Golden", "Diamond", "Stoic", "Aggressive", "Alpha", "Beta", "Gamma", "Hedged", "Fibonacci", "Limit", "Parabolic", "Oversold"];
export const ANIMALS = ["Capybara", "Falcon", "Shark", "Whale", "Dolphin", "Owl", "Fox", "Wolf", "Eagle", "Lion", "Tiger", "Badger", "Otter", "Penguin", "Koala", "Panda", "Sloth", "Hedgehog", "Octopus", "Honeybadger"];

export const generateAnonymousName = () => {
    const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
    const animal = ANIMALS[Math.floor(Math.random() * ANIMALS.length)];
    return `${adj} ${animal}`;
};
